// Race-free hand-off for "deal the next local game with THIS player count, not the default".
//
// The demo-table button (HOLE #18) must deal a 7-player game on the FIRST mount of the play surface.
// The previous approach (App dispatches a `mj:start-demo` window event via setTimeout(0) and
// SoloMahjong's mount effect deals the default 4p) had a race: the setTimeout could fire BEFORE the
// effect that registers the listener, so the event was dropped and the board stayed 4p. Worse, even
// when caught it double-dealt (4p flash then 7p).
//
// Instead App sets the pending count SYNCHRONOUSLY before switching to the play screen, and
// SoloMahjong's mount effect consumes it — so the very first deal uses the right count, no event, no
// race, no flash. consume() is one-shot (returns null after the first read).
let pendingDemoPlayers: number | null = null;

/** Reserve the player count for the next local mount-deal. Clamped to 1..7. Call before setScreen('play'). */
export function setPendingDemo(players: number): void {
  pendingDemoPlayers = Math.min(7, Math.max(1, Math.floor(players)));
}

/** Read & clear the pending demo player count (null if none pending). */
export function consumePendingDemo(): number | null {
  const p = pendingDemoPlayers;
  pendingDemoPlayers = null;
  return p;
}
